import API from './API.js'
import axios from 'axios'

export default class Edu_seasons extends API {
  constructor() {
    super('edu_seasons')
  }

  async register_available(){
    const response = await axios.get(`/edu_seasons/register_available`)
    return response.data  }
}
